import * as Sentry from "@sentry/react";
import { SENTRY_URL, environment } from "../config/config";

//sentry configuration function for more info refer
//https://docs.sentry.io/platforms/javascript/?original_referrer=https%3A%2F%2Fsentry.io%2F
const configureSentry = () => {
  if (process.env.NODE_ENV === "production") {
    Sentry.init({
      dsn: SENTRY_URL,
      environment,
      beforeSend: (event) => {
        if (window.location.hostname === "localhost") {
          return null;
        }
        return event;
      },
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: [
            // "localhost",
            "https://partnertest.varahaag.com/",
            "https://partner.varahaag.com/",
          ],
        }),
        new Sentry.Replay(),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
};
export default configureSentry;
